import { EMP_INFO_SYSTEM_NAME } from '../constants/StandardEmploymentInformationSystemName.js';
import type { TaetigkeitsBaseData } from './TaetigkeitsBaseData.js';

export const Vertragsform = [
  {
    [EMP_INFO_SYSTEM_NAME]: 1,
    Bezeichnung: 'Vollzeit unbefristet',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 2,
    Bezeichnung: 'Teilzeit unbefristet',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 3,
    Bezeichnung: 'Vollzeit befristet',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 4,
    Bezeichnung: 'Teilzeit befristet',
  },
] satisfies TaetigkeitsBaseData;

export const VertragsformFullTime = [1, 3];
export const isVertragsformFullTime = (form: number) => VertragsformFullTime.includes(form);
export const VertragsformPartTime = [2, 4];
export const isVertragsformPartTime = (form: number) => VertragsformPartTime.includes(form);

export const VertragsformUnbefristet = [1, 2];
export const isVertragsformUnbefristet = (form: number) => VertragsformUnbefristet.includes(form);
export const VertragsformBefristet = [3, 4];
export const isVertragsformBefristet = (form: number) => VertragsformBefristet.includes(form);
